import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import CustomSidebar from "../../components/common/Sidebar/Sidebar";
import Loader from "../../components/common/Loader";
import { getOnboardingStatus } from "../../services/fundraiserService";

const FeaturedForm = ({ element }) => {
    const [isSideBarOpen, setisSideBarOpen] = useState(true);
    const [isCheckingStatus, setIsCheckingStatus] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state?.authReducer?.tokenData?.token);
    const user = useSelector((state) => state?.authReducer?.tokenData?.user);
    const userRole = user?.role?.toLowerCase();

    useEffect(() => {
        // Only check for fundraisers
        if (userRole === "fundraiser" && token) {
            const checkStatus = async () => {
                try {
                    const statusPromise = await dispatch(getOnboardingStatus()).unwrap();
                    const detailsSubmitted = statusPromise?.data?.detailsSubmitted === true;
                    const chargesEnabled = statusPromise?.data?.chargesEnabled === true;

                    // If Stripe is not complete, redirect to welcome
                    if (!detailsSubmitted || !chargesEnabled) {
                        if (detailsSubmitted && !chargesEnabled) {
                            navigate("/complete-setup", { replace: true });
                        } else {
                            navigate("/fundraiser/welcome", { replace: true });
                        }
                        return;
                    }

                    // Stripe is complete, allow dashboard access
                    setIsCheckingStatus(false);
                } catch (error) {
                    // On error, redirect to welcome
                    navigate("/fundraiser/welcome", { replace: true });
                }
            };

            checkStatus();
        } else {
            // For non-fundraisers or no token, show immediately
            setIsCheckingStatus(false);
        }
    }, [userRole, token, dispatch, navigate]);

    // Show white screen with loader while checking
    if (isCheckingStatus && userRole === "fundraiser") {
        return (
            <div className="w-full h-screen flex items-center justify-center bg-white">
                <Loader />
            </div>
        );
    }

    return (
        <div className="flex h-full w-full fixed">
            <CustomSidebar isSideBarOpen={isSideBarOpen} setisSideBarOpen={setisSideBarOpen} />
            <Navbar isSideBarOpen={isSideBarOpen} setisSideBarOpen={setisSideBarOpen} element={element} />
        </div>
    )
}

export default FeaturedForm;